import axios from 'axios'
import qs from 'qs'
import TransportChainScenarioService from './TransportChainScenarioService'
import CountryService from './CountryService'
import UnitsWeightService from './UnitsWeightService'
import AvailablePathService from './AvailablePathService'
import MeasurementUnitService from './MeasurementUnitService'
import VolumeUnitService from './VolumeUnitService'
import ProductCategoriesService from './ProductCategoriesService'
import ColdChainTypeService from './ColdChainTypeService'
import FileService from './FileService'
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-type': 'application/json'
  }
})

export default {
  transportChainScenarioService: new TransportChainScenarioService(axiosInstance),
  countryService: new CountryService(axiosInstance),
  unitsWeightService: new UnitsWeightService(axiosInstance),
  availablePathService: new AvailablePathService(axiosInstance),
  measurementUnitService: new MeasurementUnitService(axiosInstance),
  volumeUnitService: new VolumeUnitService(axiosInstance),
  productCategoriesService: new ProductCategoriesService(axiosInstance, qs),
  fileService: new FileService(axiosInstance),
  coldChainTypeService: new ColdChainTypeService(axiosInstance)
}
